
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import { VMenu } from '@/types/Components';
    import { ReisestatistikOptions } from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['printReiseReport', 'exportReiseReport']),
        },
    })
    export default class Reisestatistik extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public printReiseReport!: (payload: { options: ReisestatistikOptions }) => void;
        public exportReiseReport!: (payload: { options: ReisestatistikOptions }) => void;

        public zeitraumMenu = false;

        public options: ReisestatistikOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            gruppierungAerzte: false,
        };

        public get canPrint(): boolean {
            return this.options.zeitraum.length === 2;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);
        }

        public onClickPrint(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.printReiseReport({ options });
        }

        public onClickExport(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.exportReiseReport({ options });
        }
    }
